import { huge, type HugeNumber } from "@/shared/numbers";

// JS-number-limit boundary (~Number.MAX_VALUE). String-encoded so
// break_eternity parses it exactly. NHov branch effects are clamped here until
// `outside-nhov`; MHov uses the same boundary for its pre-achievement hard cap
// and post-achievement softcap.
export const NUMBER_LIMIT_BOUNDARY: HugeNumber = huge("1.8e308");
